enum UserRoles {
    ADMIN = "ADMIN",
    USER = "USER",
    PROVIDER = "PROVIDER"
}

export default UserRoles;